module.exports = __webpack_public_path__ + "assets/img/ppt.a558de08.svg";